<p>queue-alerts works!</p>
<div>
  <router-outlet></router-outlet>
</div>
